import { useMetricDetailsMapContext } from '../../../../context/contexts';
import { useMetricQueries } from '../common/hooks';
import { DataOrError } from '../common/types';
import {
  getKpiSectionResponseFromQueryResults,
  getQueriesForKpiSectionConfig,
} from '../common/utils';
import {
  KpiFactboxSingleMetricVizConfig,
  KpiFactboxSingleMetricVizData,
  KpiFactboxSingleMetricVizExternalProps,
} from './types';

export const useKpiFactboxSingleMetricConfigToData = (
  config: KpiFactboxSingleMetricVizConfig,
  externalProps: KpiFactboxSingleMetricVizExternalProps
): DataOrError<KpiFactboxSingleMetricVizData> => {
  const { locale } = externalProps;
  const metricDetailsMap = useMetricDetailsMapContext();
  const queries = getQueriesForKpiSectionConfig(config.section);
  const { queryResponses } = useMetricQueries({
    queries,
    timeSliderState: externalProps.timeSliderState,
    segmentationState: externalProps.segmentationState,
    filtersState: externalProps.filtersState,
  });
  const kpiSectionValue = getKpiSectionResponseFromQueryResults(
    queryResponses,
    config.section,
    metricDetailsMap,
    locale.selected
  );
  const { title, subtitle, footer } = config;
  return {
    data: {
      title: title?.[locale.selected],
      subtitle: subtitle?.[locale.selected],
      footer: footer?.[locale.selected],
      fontSize: config.fontSize,
      dataResponse: {
        sectionValue: kpiSectionValue,
      },
      metricDetailsMap: metricDetailsMap,
    },
    error: null,
  };
};
